<div class="chip-group__chips" role="presentation">
  <ng-content></ng-content>
</div>
